module.exports = __webpack_public_path__ + "static/media/feelingProud.08921358.svg";